<template>
  <div class="kpiset-modal">
    <div ref="KPISetEditModal" class="modal fade" data-bs-backdrop="static" id="KPISetEditModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" v-draggable-modal>
        <div class="modal-content bg-primary">
          <div class="modal-header">
            <div class="h5 modal-title text-light"> {{ $t("views.kpiSet.detail.headingCard") }} <DocsInfoLink color="light" target="manageKPISets"></DocsInfoLink>
            </div>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body bg-light">
            <div v-if="elementType === 'kpiSet'" class="form-link">
              <div class="mb-3">
                <label for="kpiSetName" class="form-label">{{ $t("views.kpiSet.edit.name") }}<span class="text-danger">*</span></label>
                <input v-model="form.kpiSet.name.content" id="kpiSetName" :class="form.kpiSet.name.error === '' ? 'form-control' : 'form-control is-invalid'">
                <div class="invalid-feedback">{{ form.kpiSet.name.error }}</div>
              </div>
              <div class="mb-3">
                  <label for="kpiSetDescription" class="form-label">{{ $t("views.kpiSet.edit.description") }}</label>
                  <RTEditor ref="kpiSetDescription" v-model="form.kpiSet.description.content" contentType="html" id="kpiSetDescription"></RTEditor>
                  <div class="quill-invalid-feedback">{{ form.kpiSet.description.error }}</div>
              </div>
            </div>
            <div v-if="elementType === 'kpi'" class="form-org-unit">
              <div class="row mb-3">
                <div class="col">
                  <label for="existingKpis" class="form-label">{{ $t("views.kpiSet.edit.selectKPI") }}<span class="text-danger">*</span></label>
                  <select v-model="form.kpi.kpiId.content" class="form-select" id="kpi" :class="form.kpi.kpiId.error === '' ? 'form-control' : 'form-control is-invalid'">
                    <option v-for="kpi in kpisList" :key="kpi.id" :value="kpi.id" :disabled="kpi.folder ? true : false">
                      {{ kpi.name }}
                    </option>
                  </select>
                  <div class="invalid-feedback">{{ form.kpi.kpiId.error }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer bg-light justify-content-between">
            <div>
              <button v-if="elementType === 'kpiSet'" type="button" class="btn btn-sm btn-outline-danger" :class="selectedKPISet.hasNodes ? 'disabled' : ''" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#KPISetDeleteModal">{{ $t("general.delete") }}</button>
            </div>
            <div>
              <button type="button" class="btn btn-sm btn-outline-secondary me-2" data-bs-dismiss="modal">{{ $t("general.close") }}</button>
              <button @click="save()" type="button" class="btn btn-sm btn-primary">{{ $t("general.save") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import initializeForm from '@/composables/initializeForm'
import setFormContent from '@/composables/setFormContent'
import * as validation from '@/composables/validation'
import DocsInfoLink from '@/components/DocsInfoLink.vue'
import RTEditor from '@/components/RTEditor.vue'
import { Modal } from 'bootstrap'
import { ref } from 'vue'

export default {
  name: 'KPISetEditModal',
  mounted () {
    const myModalDialog = document.getElementById('KPISetEditModal')

    myModalDialog.addEventListener('shown.bs.modal', event => {
      const mode = this.$parent.KPISetModalMode
      if (mode === 'add') {
        initializeForm(this.form.kpiSet)
        initializeForm(this.form.kpi)
      }
    })
    myModalDialog.addEventListener('hidden.bs.modal', event => {
      const mode = this.$parent.KPISetModalMode
      if (mode !== 'add' && mode !== 'delete') {
        setFormContent(this.form, this.$store.state.selectedKPISet, 'kpiSet', this.elementType, this.$parent.KPISetModalElementId)
      }
    })
  },
  data () {
    return {
      form: {
        kpiSet: {
          name: {
            content: '',
            error: '',
            maxLength: 255,
            validate: ['empty', 'length']
          },
          description: {
            content: '',
            error: '',
            validate: [],
            rtEditor: true,
            ref: 'kpiSetDescription'
          },
          responsible: {
            content: '',
            error: '',
            validate: []
          }
        },
        kpi: {
          kpiId: {
            content: '',
            error: '',
            validate: ['empty']
          },
          pos: {
            content: '',
            error: '',
            validate: []
          },
          name: {
            content: '',
            error: '',
            validate: []
          }
        }
      }
    }
  },
  components: {
    DocsInfoLink,
    RTEditor
  },
  computed: {
    selectedKPISet () {
      return this.$store.state.selectedKPISet
    },
    KPISetsList () {
      return this.$store.state.kpiSetsList
    },
    kpisList () {
      return this.$store.state.kpisList
    },
    elementId () {
      return this.$parent.KPISetModalElementId
    },
    elementType () {
      return this.$parent.KPISetModalElementType
    },
    mode () {
      return this.$parent.KPISetModalMode
    },
    isAdmin () {
      return this.$store.state.user.role === 10387
    }
  },
  methods: {

    async save () {
      this.$store.commit('SET_LOADING_STATUS', true)

      let valid = 0
      if (this.elementType === 'kpiSet') valid = validation.fieldValidation(this.form.kpiSet)
      if (this.elementType === 'kpi') {
        valid = validation.fieldValidation(this.form.kpi)
      }

      if (valid === 0) {
        Object.keys(this.form[this.elementType]).forEach(field => {
          if (this.form[this.elementType][field].rtEditor) {
            const ref = this.form[this.elementType][field].ref
            if (this.$refs[ref]) {
              this.form[this.elementType][field].content = this.$refs[ref].getContent()
            }
          }
        })
        const elementData = Object.assign(
          ...Object.entries(this.form[this.elementType]).map(([key, value]) => ({ [key]: value.content }))
        )

        elementData.id = this.elementId
        let dispatchFunc = ''
        if (this.elementType !== 'kpiSet') {
          elementData.elementType = (this.elementType + 's')
          elementData.kpiSetId = this.selectedKPISet.id
        }
        dispatchFunc = this.elementType === 'kpiSet' ? (this.mode + 'KPISet') : (this.mode + 'KPISetElement')
        await this.$store.dispatch(dispatchFunc, elementData).then(() => {
          this.closeModal()
        })
      }

      this.$store.commit('SET_LOADING_STATUS', false)
      if (this.elementType === 'kpiSet' && this.mode === 'add') {
        await this.$store.dispatch('getKPISets', { validFrom: this.$parent.filterValidFrom, validTo: this.$parent.filterValidTo })
      }
    },
    updateModalContent () {
      setFormContent(this.form, this.elementType, this.$store.state.selectedKPISet, 'kpiSet')
    }
  },
  watch: {
    elementId () {
      const mode = this.$parent.kpiSetModalMode
      if (mode === 'update') {
        setFormContent(this.form, this.$store.state.selectedKPISet, 'kpiSet', this.elementType, this.$parent.kpiSetModalElementId)
      }
    },
    mode (newMode) {
      if (newMode === 'update') {
        setFormContent(this.form, this.$store.state.selectedKPISet, 'kpiSet', this.elementType, this.$parent.kpiSetModalElementId)
      }
    }
  },
  setup () {
    const KPISetEditModal = ref(null)
    const closeModal = () => Modal.getInstance(KPISetEditModal.value)?.hide()
    return { KPISetEditModal, closeModal }
  }
}
</script>
